var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGmiImg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.59043 3.54672L2.14041 11.0177C1.97253 11.1856 1.77302 11.2696 1.54189 11.2696C1.31133 11.2696 1.1121 11.1856 0.944214 11.0177C0.776326 10.8498 0.692383 10.6503 0.692383 10.4192C0.692383 10.1886 0.776326 9.98941 0.944214 9.82152L8.41522 2.3715H2.03548C1.79764 2.3715 1.59814 2.2912 1.43696 2.13058C1.27635 1.96941 1.19605 1.76991 1.19605 1.53207C1.19605 1.29422 1.27635 1.09472 1.43696 0.933546C1.59814 0.772933 1.79764 0.692627 2.03548 0.692627H10.4299C10.6677 0.692627 10.8669 0.772933 11.0275 0.933546C11.1887 1.09472 11.2693 1.29422 11.2693 1.53207V9.92645C11.2693 10.1643 11.1887 10.3635 11.0275 10.5241C10.8669 10.6853 10.6677 10.7659 10.4299 10.7659C10.192 10.7659 9.9928 10.6853 9.83219 10.5241C9.67102 10.3635 9.59043 10.1643 9.59043 9.92645V3.54672Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmiImg2);
export default __webpack_public_path__ + "static/media/gmi_img2.ce894f50f584b6660c64c9f89c1a9298.svg";
export { ForwardRef as ReactComponent };